module.exports = __webpack_public_path__ + "img/regactive.a802fb45.png";